import { cached, tracked } from '@glimmer/tracking';
import { toggleValue } from 'uplisting-frontend/utils/toggle-value';
import {
  BaseAbstractFilterParams,
  type IBaseFilterParams,
  BaseAbstractFilter,
  FilterComponent,
} from 'uplisting-frontend/utils/filters/abstract/-base';

export class MultiSelectListFilterParams
  extends BaseAbstractFilterParams<string[]>
  implements IBaseFilterParams<string[], string>
{
  @tracked value = [];

  @cached
  get selectedRecords(): string[] {
    return this.value;
  }

  public updateValue(value: string): void {
    toggleValue(this, 'value', value);
  }

  public toQuery(): string[] {
    return this.value;
  }

  public reset(): void {
    this.value = [];
  }

  public selectAll(): void {
    this.value = [...this.filter.options] as never[];
  }
}

export abstract class MultiSelectListFilter extends BaseAbstractFilter<
  string[],
  string
> {
  component = FilterComponent.multiSelectList;

  constructor(value?: string[]) {
    super(new MultiSelectListFilterParams(value));
  }

  public selectAll(): void {
    (this.params as MultiSelectListFilterParams).selectAll();
  }
}
